import { createApp,reactive } from "vue";
import Loading from "./loading.vue";


const divDom = document.createElement('div')


divDom.setAttribute('class','loading-container')


const options = reactive({
    showToast: true,
    txt: 'Loading...',
    progress: 3,
    opacity: .3
})


const $loading = createApp(Loading,{options}).mount(divDom)


const loadPlguin = {
    show({txt,opacity}) {
        options.showToast = true
        options.txt = txt
        options.opacity = opacity || 1
        document.body.appendChild($loading.$el)
    },
    hide() {
        options.showToast = false
        options.progress = 0
    },
    changeProgress(progress) {
        options.progress = progress
    }
}


export default {
    install(app) {
        app.config.globalProperties.$loading =  loadPlguin 
    }
}

